<div class="tabs-wrapper clean-horizontal-scroll">
  <button *ngFor="let tab of tabs; let i = index"
          (click)="selectTab(i)"
          [class.active]="tab.active"
          [style.border-radius]="tabBorderRadius + 'px'">
    {{tab.title}}
  </button>
</div>
<ng-content></ng-content>
